<template>
  <div class="login-main-view">
    <el-dropdown class="signature" trigger="click">
      <span class="el-dropdown-link">
        开发接入<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="handleClick('signature')">验签工具</el-dropdown-item>
        <el-dropdown-item @click.native="handleClick('branchCode')">支行查询工具</el-dropdown-item>
        <el-dropdown-item @click.native="handleClick('mccCode')">mcc查询工具</el-dropdown-item>
        <el-dropdown-item @click.native="handleClick('areaCode')">地区码查询工具</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <transition name="el-fade-in-linear">
      <div class="login-container" v-show="!isShowForgetPWPage">
        <div class="login-content">
          <!-- <div class="login-logo" /> -->
          <div class="login-content-img" />
          <div class="login-title">
            <div>智掌柜</div>
            <div>代理商管理系统</div>
          </div>
          <div class="img-foot">
            <!-- <span class="foot-txt" @click="toRegisterAgent">成为支付服务商></span> -->
            <!-- <span class="foot-txt" @click="scanDownloadVisible=true">扫描下载收银通></span> -->
          </div>
          <div class="form-container">
            <el-form
              :model="data"
              ref="data"
              :rules="loginRules"
              class="login-form"
              label-position="left"
              v-loading="login_actions.disabled"
            >
              <div class="title">欢迎登录</div>
              <div class="item-title">账号</div>
              <el-form-item class="form-item-container" prop="userName">
                <el-input
                  v-model="data.userName"
                  name="userName"
                  type="text"
                  placeholder="请输入账户名"
                  class="username"/>
              </el-form-item>
              <div class="item-title">登录密码</div>
              <el-form-item class="form-item-container" prop="password">
                <el-input v-model="data.password" :type="pwdType" placeholder="请输入用户密码" name="password">
                  <i slot="suffix" class="el-icon-view" @click="showPwd" style="margin-right:15px;font-size: 16px;cursor:pointer"></i>
                </el-input>
              </el-form-item>
              <div class="item-title">验证码</div>
              <el-form-item class="form-item-container no-border" prop="verifyCode" style="border:none">
                <el-input
                  v-model="data.verifyCode"
                  class="verify-code"
                  placeholder="请输入验证码"
                  autocomplete="on"/>
                <img
                  :src="verifySrc"
                  class="verify"
                  width="114"
                  height="46"
                  style="background: rgba(238,238,238,1);border-radius:4px;margin:2px;cursor:pointer"
                  @click="getVerifyCode()"/>
              </el-form-item>
              <div style="display:flex">
                <!-- <el-button v-loading="loading" type="primary" class="login-btn" @click.native.prevent="merchantOnLogin('data')">商户登录</el-button> -->
                <el-button v-loading="loading" type="primary" class="agent-login-btn" @click.native.prevent="agentOnLogin('data')">代理商登录</el-button>
              </div>
              <div class="fr" @click="forgetPwButtonClick">忘记密码？</div>
            </el-form>
          </div>
        </div>
        <div class="footer-new">
          <div class="footer-text">© 2019-2025 lszzg.com，All rights reserved.</div>
          <div class="line"></div>
          <div class="footer-text" @click="toUrl(0)"><img class="footer-text-img" src="https://www.lszzg.com/images/zzg/gongshang-plice.png"/>深圳市市场监督管理局（工商网监）</div>
          <div class="line"></div>
          <div class="footer-text" @click="toUrl(1)">粤公网安备 44030502004014号</div>
          <div class="line"></div>
          <div class="footer-text" @click="toUrl(2)">粤ICP备18147159号</div>
        </div>
      </div>
    </transition>
    <transition name="el-fade-in-linear">
      <div v-show="isShowForgetPWPage">
        <el-form
          ref="forgetPwForm"
          class="forget-pw-form"
          :model="forgetPwData"
          :rules="forgetPwRule"
          label-width="80px"
          label-position="left"
          v-loading="forgetPwLoading">
          <i class="el-icon-back forget-pw-back" @click="isShowForgetPWPage = false"></i>
          <h5 class="title">密码找回</h5>
          <el-form-item label="账户类型" prop="roleType">
            <el-select v-model="forgetPwData.roleType" placeholder="请选择">
              <!-- <el-option label="商户" :value="1"></el-option> -->
              <el-option label="代理商" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="注册账户" prop="userName">
            <el-input v-model="forgetPwData.userName" placeholder="请输入您的注册账号"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input v-model="forgetPwData.password" type="password" placeholder="请输入新密码"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confrimPassword">
            <el-input v-model="forgetPwData.confrimPassword" type="password" placeholder="请再次输入新密码"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="mobile">
            <el-input v-model="forgetPwData.mobile" :maxlength="11" placeholder="请输入您的手机号码"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="validCode">
            <el-input v-model="forgetPwData.validCode" :maxlength="6" placeholder="请输入验证码">
              <el-button style="width: 112px;" slot="append" @click="getValidCode">{{ validCodeCountDown > 0 ? `${validCodeCountDown}s` : '发送验证码' }}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item label-width="0">
            <div style="text-align: center;">
              <el-button class="find-pw-button" type="info" @click="isShowForgetPWPage = false">返回登录</el-button>
              <el-button class="find-pw-button" type="primary" @click="findPwClick">找回密码</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </transition>
    <el-dialog :visible.sync="dialogFormVisible" size="small" width="1000px" :close-on-click-modal="false">
      <agentRegister :value="registerInfo" :visible.sync="dialogFormVisible" v-if="dialogFormVisible" @success="registerSuccess" :error-msg="errorMsg" :fromBd="fromBd" :bdInfo="bdInfo"></agentRegister>
    </el-dialog>
    <el-dialog
      title="扫码下载收银通"
      :visible.sync="scanDownloadVisible"
      center
      width="330px">
      <img src="../../../static/images/syt-app-qr.png">
    </el-dialog>
    <el-dialog title="" :visible.sync="showSuccessVisible" width="450px" :close-on-click-modal="false">
      <div class="successDiv">
        <img src="@/assets/img/success.png" alt="" class="successIcon"/>
        <p class="colorTitle">提交成功</p>
        <p class="account">代理商登录账号为： <span>{{agentAccount}}</span></p>
        <div class="tips">
          <p>可随时登录查看入网审核结果</p>
          <ul>
            <li>审核中→请耐心等待</li>
            <li>审核未通过→可重新编辑资料提交</li>
            <li>审核通过→直接登录后台</li>
          </ul>
        </div>
        <el-button type="primary" @click="showSuccessVisible = false">返回登录页</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
// eslint-disable-next-line camelcase
import { hex_md5 } from '@/utils/md5.min.js'
import { validCode } from '@/api/global.js'
import { agentLogin, merchantLogin, csrfToken, authCode, forgetPassword } from '@/api/user.js'
import md5 from 'js-md5'
import store from '@/store'
import agentRegister from './agentRegister'
import { validStrictPsd, strictPsdError, validSimplePsd, simplePsdError } from '@/utils/validate.js'

export default {
  name: 'Login',
  components: {
    agentRegister
  },
  data () {
    const validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入正确的用户名'))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value.length < 5) {
        callback(new Error('密码不能小于6位'))
      } else {
        callback()
      }
    }
    return {
      data: {
        userName: '',
        password: '',
        verifyCode: ''
      },
      login_actions: {
        disabled: false
      },
      loginRules: {
        userName: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePass }]
      },
      loading: false,
      pwdType: 'password',
      isShowForgetPWPage: false,
      forgetPwLoading: false,
      scanDownloadVisible: false,
      forgetPwData: {
        roleType: 1,
        userName: '',
        mobile: '',
        validCode: '',
        password: '',
        confrimPassword: ''
      },
      forgetPwRule: {
        roleType: [{ type: 'number', required: true, message: '请选择账户类型', trigger: 'blur' }],
        userName: [{ required: true, message: '请输入注册账号', trigger: 'blur' }],
        password: [{
          validator: (rule, value, callback) => {
            // 代理商版密码校验
            if (this.forgetPwData.roleType === 2) {
              if (validStrictPsd(value)) {
                callback()
              } else {
                return callback(new Error(strictPsdError))
              }
            } else {
              if (validSimplePsd(value)) {
                callback()
              } else {
                return callback(new Error(simplePsdError))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        confrimPassword: [{
          validator: (rule, value, callback) => {
            if (this.forgetPwData.roleType === 2) {
              if (!value) {
                callback(new Error('请输入8-20位大写/小写字母/数字/符号中的至少三种组合'))
              } else if (value !== this.forgetPwData.password) {
                callback(new Error('两次输入的新密码不一致!'))
              } else if (!validStrictPsd(value)) {
                callback(new Error(strictPsdError))
              } else {
                callback()
              }
            } else {
              if (!value) {
                callback(new Error(simplePsdError))
              } else if (value !== this.forgetPwData.password) {
                callback(new Error('两次输入的新密码不一致!'))
              } else if (!validSimplePsd(value)) {
                callback(new Error(simplePsdError))
              } else {
                callback()
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { len: 11, message: '请输入11位手机号码', trigger: 'blur' }
        ],
        validCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 6, message: '请输入6位验证码', trigger: 'blur' }
        ]
      },
      validCodeCountDown: 0,
      qrWarningDialogVisible: false,
      dialogFormVisible: false, // 代理商入网弹窗显示
      originPsd: '', // 加密前的密码
      verifySrc: '', // 图片验证码
      isOldHref: false, // 是否是旧域名
      registerInfo: {}, // 被驳回的代理商入网信息
      errorMsg: '', // 被驳回的错误信息
      showSuccessVisible: false, // 提交入网申请成功弹窗
      agentAccount: '', // 提交入网申请成功的代理商账号
      fromBd: false,
      bdInfo: ''
    }
  },
  methods: {
    toUrl (value) {
      const externalLinks = [
        'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502004014',
        'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502004014',
        'https://beian.miit.gov.cn/'
      ]
      window.open(externalLinks[value])
    },
    showPwd () {
      if (this.pwdType === 'password') {
        this.pwdType = ''
      } else {
        this.pwdType = 'password'
      }
    },
    toObj (v) {
      var o = {}
      for (var i = 0; i < v.length; i++) {
        if (!o[v[i]]) {
          o[v[i]] = v[i]
        }
      }
      return JSON.stringify(o)
    },
    agentOnLogin (ref, type) {
      var that = this
      // var pw = that.data.password
      that.originPsd = that.data.password
      var data = { ...this[ref] }
      data.password = md5(data.password)
      data = qs.stringify(data)
      this.$refs[ref].validate((valid) => {
        if (valid) {
          return new Promise((resolve, reject) => {
            agentLogin(data).then(response => {
              if (response.error_code === '0') {
                this.login_actions.disabled = false
                const data = { ...response }
                localStorage.setItem('navBar', JSON.stringify(response.navBar))
                localStorage.setItem('ZZGAgentUser', JSON.stringify(data.user))
                localStorage.setItem('ZZGAgentToken', data.token)
                localStorage.setItem('isTopAgent', data.isTopAgent)
                console.log('代理商登录数据======', JSON.stringify(data.user))
                store.dispatch('user/setUserInfo', data.user)
                localStorage.levelConst = JSON.stringify(data.const.levelConst)
                localStorage.payTypeConst = JSON.stringify(data.const.payTypeConst)
                localStorage.privilegeConst = JSON.stringify(data.const.privilegeConst)
                if (data.user.role.id === 10) {
                  this.$router.push({ path: '/Partner/Institution/institutionList' })
                } else {
                  this.$router.push({ path: '/index' })
                }
                this.login_actions.disabled = false
              } else {
                this.login_actions.disabled = false
                this.$message({
                  showClose: true,
                  message: response.error_msg,
                  type: 'error'
                })
                // 验证码错误
                if (response.error_code === '-1002') {
                  this.data.password = this.originPsd
                  this.data.verifyCode = ''
                } else if (response.error_code === '-1003') {
                  // 代理商入网审核不通过或者审核中
                  this.checkRegister(response.data)
                } else {
                  this.$refs.data.resetFields()
                }
              }
              this.getVerifyCode()
            }).catch(error => {
              reject(error)
            })
          })
        } else {
          this.login_actions.disabled = false
          return false
        }
      })
    },
    merchantOnLogin (ref, type) {
      var that = this
      var pw = that.data.password
      that.originPsd = that.data.password
      that.data.password = md5(pw)
      var data = { ...this[ref] }
      data = qs.stringify(data)
      this.$refs[ref].validate((valid) => {
        if (valid) {
          this.login_actions.disabled = true
          return new Promise((resolve, reject) => {
            merchantLogin(data).then(response => {
              if (response.error_code === '0') {
                this.login_actions.disabled = false
                const data = { ...response }

                localStorage.setItem('navBar', JSON.stringify(data.navBar))
                localStorage.setItem('ZZGAgentUser', JSON.stringify(data.user))
                store.dispatch('user/setUserInfo', data.user)
                this.$router.push({ path: '/index' })
                this.login_actions.disabled = false
              } else {
                this.login_actions.disabled = false
                this.$message({
                  showClose: true,
                  message: response.error_msg,
                  type: 'error'
                })
                if (response.error_code === '-1002') {
                  this.data.password = this.originPsd
                  this.data.verifyCode = ''
                } else {
                  this.$refs.data.resetFields()
                }
              }
              this.getVerifyCode()
            }).catch(error => {
              reject(error)
            })
          })
        } else {
          this.login_actions.disabled = false
          return false
        }
      })
    },
    getVerifyCode () {
      var param = {}
      param = qs.stringify(param)
      validCode(param).then((data) => {
        if (data.error_code) {
          this.verifySrc = data.verifyCodeUrl
        }
      })
    },
    /**
     * 忘记密码点击
     */
    forgetPwButtonClick () {
      this.forgetPwData.userName = this.data.userName
      this.isShowForgetPWPage = true
    },
    /**
     * @description 倒计时
     * @param {Number} count 倒计时时长
     */
    countDown (count) {
      if (count) this.validCodeCountDown = count
      if (this.validCodeCountDown > 0) {
        this.validCodeCountDown--
        setTimeout(this.countDown, 1000)
      }
    },
    /**
    * 获取找回密码验证码
    */
    getValidCode () {
      if (this.validCodeCountDown > 0) return
      if (!this.forgetPwData.mobile || this.forgetPwData.mobile.length !== 11) {
        this.$message({
          showClose: true,
          message: '请先输入11位手机号',
          type: 'warning'
        })
        return
      }
      this.sendCode(this.forgetPwData.mobile)
    },
    /**
    * 获取验证码接口
    */
    sendCode (mobile) {
      csrfToken('').then(response => {
        const token = response.token
        const sign = hex_md5(mobile + token).toUpperCase()
        const data = qs.stringify({
          mobile: mobile,
          sign: sign,
          token: token,
          channel: ''
        })
        authCode(data).then(res => {
          this.countDown(60)
        }).catch(() => {
          this.$message({
            showClose: true,
            message: '网络请求失败，请检查您的网络重试',
            type: 'error'
          })
        })
      }).catch(() => {
        this.$message({
          showClose: true,
          message: '网络请求失败，请检查您的网络重试',
          type: 'error'
        })
      })
    },
    /**
    * 找回密码点击
    */
    findPwClick () {
      let isValid = true
      this.$refs.forgetPwForm.validate((valid) => {
        isValid = valid
        return valid
      })
      if (!isValid) return
      this.forgetPassword()
    },
    /**
    * 找回密码接口
    */
    forgetPassword () {
      this.forgetPwLoading = true
      const params = Object.assign({}, this.forgetPwData)
      params.password = md5(this.forgetPwData.password)
      params.confrimPassword = md5(this.forgetPwData.confrimPassword)
      const data = qs.stringify(params)
      forgetPassword(data).then(response => {
        this.forgetPwLoading = false
        if (response.error_code === '0') {
          this.$message({
            showClose: true,
            message: '找回密码成功，请您使用新密码重新登录',
            type: 'success'
          })
          this.isShowForgetPWPage = false
        } else {
          this.$message({
            showClose: true,
            message: response.error_msg,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$message({
          showClose: true,
          message: '网络请求失败，请检查您的网络重试',
          type: 'error'
        })
      })
    },
    toRegisterAgent () {
      this.dialogFormVisible = true
      this.registerInfo = {}
    },
    // 显示迁移提醒
    showNotify (duration) {
      // 只有旧域名和测试、预发布环境显示
      if (this.isOldHref) {
        this.$notify({
          title: '域名更新通知',
          dangerouslyUseHTMLString: true,
          duration: duration,
          customClass: 'notifyDiv',
          message: '<p>聚合支付平台服务将迁至 <a href="https://jh.leshuazf.com" target="_blank" class="link">https://jh.leshuazf.com</a>，当前域名将于2019年10月31日停止使用。请尽快使用新域名进行登录。</p>'
        })
      }
    },
    handleClick (type) {
      console.log(`/${type}`)
      // let h5Domain = ''
      // switch (process.env.CUSTOM_ENV) {
      //   case 'test': {
      //     h5Domain = 'https://t-h5.lepass.cn/wap/'
      //     break
      //   }
      //   case 'pre': {
      //     h5Domain = 'https://p-h5.lepass.cn/wap/'
      //     break
      //   }
      //   case 'prd': {
      //     h5Domain = 'https://h5.leshuazf.com/wap/'
      //     break
      //   }
      //   default: {
      //     h5Domain = 'https://t-h5.lepass.cn/wap/'
      //   }
      // }
      // window.location.href = `${h5Domain}saas-combine-tool/#/${type}`
      this.$router.push({ path: `/${type}` })
    },
    // 入网状态检查
    checkRegister (data) {
      if (!data) {
        console.log('代理商入网驳回数据返回为空')
        return
      }
      // 审核未通过
      if (data.checkStatus === 0) {
        this.registerInfo = data.agentInfo
        this.errorMsg = data.checkMsg
        this.dialogFormVisible = true
      }
    },
    // 入网申请提交成功回调
    registerSuccess (res) {
      this.showSuccessVisible = true
      this.agentAccount = res.account
    }
  },
  mounted () {
    if (this.$store.getters.routes.length > 0) {
      location.reload()
    }
    this.getVerifyCode()
    if (location.href.indexOf('yeahka') >= 0 || location.href.indexOf('saas-combine') >= 0) this.isOldHref = true
    store.dispatch('permission/clearRoutes')
    store.dispatch('user/logout')
  },
  watch: {
    $route: {
      handler: function (to) {
        if (to.query && to.query.item) {
          this.fromBd = true
          this.bdInfo = to.query.item
          this.dialogFormVisible = true
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
  .login-main-view {
    height: 100%;
    position: relative;
    width: 100%;
    min-width: 1000px;
    overflow: hidden;
    background: url("../../assets/img/login-bg.png") no-repeat;
    background-size: cover;
    .signature {
      position: absolute;
      right: 50px;
      top: 20px;
      font-size: 16px;
      z-index:20;
      color: #fff;
    }
  }
  .login-container{
    height: 100%;
    width: 100%;
    overflow: hidden;
    // background: url("../../assets/img/login-bg.png") no-repeat;
    // background-size: cover;
    position: relative;

    .footer-new {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 14px;
    // background-color: #333;
    justify-content: space-around;
    min-width: 900px;
    height: 40px;
    padding-left: 10px;
    padding-right: 10px;
    .line {
      height: 50%;
      background-color: #efefef;
      width: 1px;
    }
    .footer-text {
            color: #efefef;
            font-size: 12px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            color: #efefef;
            font-size: 12px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            /* 默认光标 */
            cursor: default;
            /* 鼠标悬停变手指 */
            transition: color 0.15s ease;
            }
            .footer-text-img {
            height: 18px;
            width: 18px;
            margin-right: 5px;
          }
        .footer-text:hover {
            cursor: pointer;
            color: #ffffff;
        }
  }

    .login-content{
      display: flex;
      align-items: center;
      width:910px;
      height:540px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      border-radius: 11px;
      background:rgba(255,255,255,1);
    }
    .login-logo{
      background: url("../../assets/img/logo.png") no-repeat;
      width: 80px;
      height: 30px;
      background-size: 100%;
      position: absolute;
      top: 50px;
      left:23px;
    }
    .login-content-img{
      width: 410px;
      height: 540px;
      background: url("../../assets/img/login-left-img.png") no-repeat;
      background-size: 100%;
    }
    .login-title {
      position: absolute;
      top:71px;
      left:38px;
      color:#fff;
      font-size:28px;
      font-weight: Bold;
    }
    .img-foot {
      position:absolute;
      bottom:15px;
      color:#fff;
      display:flex;
      justify-content:center;
      width:410px
    }
    .foot-txt{
      width:110px;
      height:12px;
      font-size:14px;
      font-family:Microsoft YaHei;
      font-weight:400;
      color:rgba(198,228,255,1);
      margin:10px;
      cursor:pointer
    }
    .login-form {
      position: relative;
    }
    .title{
      width:105px;
      height:26px;
      font-size:26px;
      font-family:Microsoft YaHei;
      font-weight:400;
      color:rgba(51,51,51,1);
      margin-bottom: 20px;
      position:relative;
      top:-20px;
    }
    .item-title{
      width:80px;
      height:14px;
      font-size:14px;
      margin-bottom: 12px;
      font-family:Microsoft YaHei;
      font-weight:400;
      color:rgba(51,51,51,1);
    }
    .username .el-input__inner {
      height:50px;
    }
    .form-item-container{
      display: flex;
      align-items: center;
      justify-content: center;
      & .el-input.verify-code{
        width:270px;
        height: 48px;
        line-height: 48px;
        margin-right:10px;
        border:1px solid rgba(232,234,236,1);
      }
    }
    .form-container{
      width: 398px;
      margin: 0 auto;
    }
    .fr{
      float:right;
      margin-top:20px;
      cursor:pointer;
    }
    .el-form-item.form-item-container.no-border{
      .el-form-item__content{
        border:1px solid #fff
      }
    }
    .el-form-item__content{
      display: flex;
      align-items: center;
      border:1px solid rgba(232,234,236,1);
      justify-content: center;
      width:410px;
      height:50px;
      border:1px solid rgba(238,238,238,1);
      border-radius:4px;
      line-height: 50px;
    }
    .el-input__inner{
      height:50px;
      line-height: 50px;
      background: transparent;
      border-radius: 0px;
      color:rgba(67,71,106,1);
      caret-color: rgba(67,71,106,1);
      -webkit-appearance: none;
      border: none;
      // &:-webkit-autofill {
      //   box-shadow: 0 0 0px 1000px #2d3a4b inset !important;
      //   -webkit-text-fill-color: #fff !important;
      // }
    }
    .el-input__suffix-inner{
      line-height: 53px;
    }
    .el-input__inner:focus{
      border: none;
    }
    .el-button{
      width:195px;
      height:44px;
      background:rgba(64,158,255,1);
      border-radius:4px;
      &.agent-login-btn{
        background:rgba(255,154,64,1);
        border:1px solid rgba(255,154,64,1);
        width: 100%;
      }
    }
    .el-button:hover,.el-button:focus{
      background:rgba(60,98,255,1);
      border:1px solid rgba(60,98,255,1);
    }
  }
  .forget-pw-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 400px;
    margin: 150px auto;
    border: 1px solid #2c387a;
    padding: 46px 30px;
    background: #fff;
    .title {
      font-size: 26px;
      margin: 0px auto 40px auto;
      text-align: center;
      color: #454545;
    }
    .find-pw-button {
      width: 140px;
    }
  }
  .successDiv{
    text-align: center;
    .successIcon{
      width: 71px;
      height: 71px;
      margin-bottom: 28px;
    }
    .colorTitle{
      color: #01BC6F;
      font-size: 22px;
      margin-bottom: 10px;
      font-weight: 400;
    }
    .account{
      font-size: 18px;
      color: #333;
      font-weight: 400;
      margin-bottom: 27px;
      span{
        font-size: 20px;
      }
    }
    .tips{
      font-size: 14px;
      color: #a3a3a3;
      width: 270px;
      margin: 0 auto;
      text-align: left;
      font-weight: 400;
      p{
        margin-bottom: 10px;
      }
      ul{
        li{
          padding-left: 10px;
          margin-bottom: 5px;
          position: relative;
          &::before{
            content: '';
            width: 2px;
            height: 2px;
            border-radius:50%;
            position: absolute;
            display: inline-block;
            transform: scale(2);
            background-color: #a3a3a3;
            left: 0;
            top: 6px;
          }
        }
      }
    }
  }
</style>
